import API, { handleRequest } from "@/api/lib/api";

export const getAttendanceReport = (
  restaurant_id,
  date,
  page = 1,
  limit = 10
) =>
  handleRequest(() =>
    API.get(
      `restaurant/staff-attendance-report/${restaurant_id}?date=${date}&page=${page}&per_page=${limit}`
    )
  );

export const getSingleStaffAllAttendanceReport = (
  staff_id,
  date,
  page = 1,
  limit = 10
) =>
  handleRequest(() =>
    API.get(
      `staff-attendance-report/${staff_id}?date=${date}&page=${page}&per_page=${limit}`
    )
  );

export const getPayrollListByStaffId = (staff_id, page, limit = 10) =>
  handleRequest(() =>
    API.get(`staff-payroll/${staff_id}?page=${page}&per_page=${limit}`)
  );

export const getPayrollStaffList = ({
  restaurant_id,
  month,
  year,
  per_page = 10,
  sort_field = "id",
  sort_order = "desc",
  search_term = "",
  page = 1,
}) =>
  handleRequest(() =>
    API.get(
      `restaurant/${restaurant_id}/payroll?month=${month}&year=${year}&per_page=${per_page}&sort_field=${sort_field}&sort_order=${sort_order}&search_term=${search_term}&page=${page}`
    )
  );

export const getPayrollHistoryList = ({
  restaurant_id,
  month,
  year,
  per_page = 10,
  sort_field = "id",
  sort_order = "desc",
  search_term = "",
  page = 1,
}) =>
  handleRequest(() =>
    API.get(
      `restaurant/${restaurant_id}/payroll-history?month=${month}&year=${year}&per_page=${per_page}&sort_field=${sort_field}&sort_order=${sort_order}&search_term=${search_term}&page=${page}`
    )
  );

export const payStaffPayroll = (restaurant_id, item_id) =>
  handleRequest(() =>
    API.post(`restaurant/${restaurant_id}/payroll/${item_id}/pay`)
  );

